<template>
    <div class="weather-wrap">
        <div class="location-box">
            <div class="location">{{ location }}</div>
            <div class="date">{{ dateBuilder() }}</div>
        </div>
        <div class="weather-box">
            <div class="weather_icon">
                <figure>
                    <b-img :src="iconUrl"></b-img>
                </figure>
            </div>
            <div class="temp">
                <div class="real_temp">{{ weather.main ? Math.round(weather.main.temp) : ''}}&#176;C</div>
                <div class="feel_like">Feels like {{ weather.main ? Math.round(weather.main.feels_like): ''}}&#176;C</div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    data () {
        return {
            weather_api_key: '920d0579044280d3249e814fcbe4e0d4',
            base_url: 'https://api.openweathermap.org/data/2.5/',
            location: 'Ho Chi Minh City',
            weather: {},
            iconUrl: null,
        }
    },
    mounted: function () {
        fetch(`${this.base_url}weather?q=${this.location}&units=metric&APPID=${this.weather_api_key}`)
            .then(res => {
                return res.json()
            }).then(result => {
                const icon = result.weather[0].icon
                this.weather = result
                this.iconUrl = 'http://openweathermap.org/img/wn/' + icon + '@2x.png'
            })
    },
    methods: {
        dateBuilder () {
            const d = new Date()
            return moment(d).format('MMMM Do YYYY, h:mm a')
        },
    },
}
</script>

<style scoped lang="scss">
@import '../styles/components/Weather.scss'
</style>
